export default "__VITE_ASSET__Doz1KCPk__"